import { useMutation, useQueryClient } from '@tanstack/react-query'
import { subscriptionApi } from '../api/subscription.api'
import type { Plan } from '../types'

export function useSubscriptionMutations() {
  const queryClient = useQueryClient()

  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: ['subscription'] })

  const createSubscription = useMutation({
    mutationFn: ({ plan, stripeToken }: { plan: Plan; stripeToken: string }) =>
      subscriptionApi.createSubscription(plan, stripeToken).then((r) => r.data.data),
    onSuccess: invalidate,
  })

  const cancelSubscription = useMutation({
    mutationFn: () => subscriptionApi.cancelSubscription(),
    onSuccess: invalidate,
  })

  const changePlan = useMutation({
    mutationFn: (plan: Plan) =>
      subscriptionApi.changePlan(plan).then((r) => r.data.data),
    onSuccess: invalidate,
  })

  return { createSubscription, cancelSubscription, changePlan }
}
